exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-kba-tablerow-column,.admin-kba-tablerow-extrernal-id{color:white !important}.admin-kba-tablerow-licence{background-color:white;color:black !important;border-left:solid 8px #0e70b6;border-radius:4px;font-weight:bold;padding:2px 6px 2px 6px}.admin-kba-tablerow-status{cursor:help;padding:2px 5px 2px 5px;border-radius:3px;margin-right:.3rem}.admin-kba-tablerow-extrernal-id{font-family:'DroidSansMonoDotted'}.admin-kba-tablerow-anonymous{width:40px;height:5px;background-color:black}.admin-kba-tablerow-state>span>i{margin-right:.3rem;opacity:.8}\n", ""]);

// exports
